import * as React from "react";
import { WebFooter } from "litb-header";

interface LayoutProps {
	isDev: boolean;
	isUat: boolean;
	cookies: { [key: string]: string };
	runtime: {
		languageCode: string;
		countryCode: string;
		currency: string;
		sid: string;
		platform: string;
	};
}
export default class Footer extends React.Component<LayoutProps, {}>{
	render() {
		return (
			<React.Fragment>
				<WebFooter {...this.props} />
			</React.Fragment>
		)
	};
}
